import React, { useState, useRef, useEffect, useCallback } from 'react';

import { useLocation, useHistory, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { AiOutlinePlus, AiOutlineMinus } from 'react-icons/ai';
import { BsFillQuestionCircleFill } from 'react-icons/bs';

import { format } from 'date-fns';
import * as Yup from 'yup';
import CryptoJS from 'crypto-js';
import omitEmpty from 'omit-empty';
import { Form } from '@unform/web';
import { BiLoaderAlt } from 'react-icons/bi';

import ApiClient from '~/utils/ApiClient';

import {
  Input,
  Select,
  ChoiceButtonLocacao,
  Textarea,
  File,
  FormChoiceButton,
  InputNoForm,
} from '~/components/Forms';

import {
  PageContainer,
  ConditionalContainer,
  LimiterInputWidth,
  MultiInputContainer,
  ActionInputMulti,
  ContainerMultiInputActions,
  TooltipContainer,
} from '~/styles/components';

import { NavBarHeader, ModalPorteFilmagem } from '~/components/Usuario';

import {
  BannerContent,
  TextBanner,
  PageContent,
  PageFooter,
  BoxHeader,
} from '~/pages/Usuario/styles';

import ImpactoListActions from '~/store/ducks/impacto-list';
import EquipamentoFilmagemListActions from '~/store/ducks/equipamento-filmagem-list';
import SomFilmagemListActions from '~/store/ducks/som-filmagem-list';
import EfeitoEspecialListActions from '~/store/ducks/efeito-especial-list';
import InstalacoesListActions from '~/store/ducks/instalacoes';
import FinalidadeBaseApoioListActions from '~/store/ducks/finalidade-base-apoio-list';
import PavimentadaListActions from '~/store/ducks/ld-area-pavimentada';
import EquipamentoEsportivoListActions from '~/store/ducks/equipamento-esportivo-list';

import { Wrap, MainLoading } from './styles';

import Button from '~/components/Button';
import { showModalMessage } from '~/services/notification';
import Chat from '~/components/Chat/chat';
import Documents from '~/components/Documents/Documents';
import {
  ModalidadePagamento,
  ObservacoesChat,
  ValorLocacao,
} from '~/components/Admin';
import LocacaoDocs from '~/pages/Usuario/Locacoes/LocacaoDocs';
import LogoIcon from '~/components/LogoIcon';
import WorkStatusSwitch from '~/components/Admin/WorkStatusSwitch';
import Header from '~/components/Header';
import BannerHeader from '~/components/BannerHeader';
import WhiteBox from '~/components/WhiteBox';
import {
  getBrowserTransformDate,
  validDateArray,
  validHourArray,
} from '~/pages/Usuario/Locacoes/functions/date-hour-utils';
import tenancy_env from '~/utils/MultiTenancyUtil';
import { ActionButton } from '~/components/Forms/FormChoiceButton/styles';
import clientResources from '~/data/clientResources';
import { DateFormMultiInput } from '~/components/Forms/DateFormMultiInput';
import { HourFormMultiInput } from '~/components/Forms/HourFormMultiInput';

export const selectCustomStyles = {
  option: provided => ({
    ...provided,
    borderBottom: `1px #ddd solid`,
    color: '#828282',
    backgroundColor: '#f2f2f2',
    padding: 16,
    fontFamily: 'PoppinsSemiBold',
    fontSize: 14,
    boxSizing: 'border-box',
    outline: 'none',
  }),
  input: provided => ({
    ...provided,
    padding: 16,
    fontSize: 14,
    margin: 0,
  }),
  container: provided => ({
    ...provided,
    padding: 0,
    marginBottom: 15,
  }),
  valueContainer: provided => ({
    ...provided,
    padding: 0,
  }),
  placeholder: provided => ({
    ...provided,
    marginLeft: 16,
    fontSize: 14,
    padding: 0,
    fontFamily: 'PoppinsSemiBold',
  }),
  control: provided => ({
    ...provided,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#d0d0d0',
    borderRadius: 2,
    boxSizing: 'border-box',
    backgroundColor: '#f2f2f2',
    boxShadow: '0 3px 12px rgba(0, 0, 0, 0.075)',
    height: 48,
    outline: 'none',
  }),
  singleValue: provided => ({
    ...provided,
    marginLeft: 16,
    fontSize: 14,
    color: '#828282',
  }),
  indicatorsContainer: provided => ({
    ...provided,
    fontSize: 10,
    color: '#828282',
  }),
};

const Praca = () => {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();

  const dadoState = location.state;
  const isAdminRequest = dadoState?.isAdminRequest || false;

  // refs
  const formRef = useRef();
  const croquiFileRef = useRef(null);
  const relatorioArteRef = useRef(null);
  const conteudoProjecaoRef = useRef(null);
  const iluminacaoFileRef = useRef(null);

  // states
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [responseLocation, setResponseLocation] = useState();
  const [openModalPorteFilmagem, setOpenModalPorteFilmagem] = useState(false);
  const [errorsForm, setErrorsForm] = useState({});

  // state choices
  const [localFilmagem, setLocalFilmagem] = useState(null);
  const [isolarLocal, setIsolarLocal] = useState(null);
  const [intervencaoArte, setIntervencaoArte] = useState(null);
  const [equipamentoEsportivo, setEquipamentoEsportivo] = useState(null);
  const [gerador, setGerador] = useState(null);
  const [blimpado, setBlimpado] = useState(null);
  const [geradorPortatil, setGeradorPortatil] = useState(null);
  const [baseLocal, setBaseLocal] = useState(null);
  const [captacaoSomDireto, setCaptacaoSomDireto] = useState(null);
  const [somFilmagem, setSomFilmagem] = useState(null);
  const [drone, setDrone] = useState(null);
  const [efeitosEspeciais, setEfeitosEspeciais] = useState(null);
  const [haveraAnimais, setHaveraAnimais] = useState(null);
  const [projecao, setProjecao] = useState(null);
  const [projecaoLogo, setProjecaoLogo] = useState(null);
  const [desligarLuz, setDesligarLuz] = useState(null);
  const [publicoPrivado, setPublicoPrivado] = useState(null);
  const [reservasVagas, setReservasVagas] = useState(null);
  const [intervencoesVia, setIntervencoesVia] = useState(null);
  const [intervencaoFlora, setIntervencaoFlora] = useState(null);
  const [pontoFixoTrajeto, setPontoFixoTrajeto] = useState(null);

  // state files
  const [croquiFile, setCroquiFile] = useState(null);
  const [dataCroquiFile, setDataCroquiFile] = useState(null);
  const [relatorioArteFile, setRelatorioArteFile] = useState(null);
  const [dataRelatorioArteFile, setDataRelatorioArteFile] = useState(null);
  const [iluminacaoFile, setIluminacaoFile] = useState(null);
  const [dataIluminacaoFile, setDataIluminacaoFile] = useState(null);
  const [conteudoProjecaoFile, setConteudoProjecaoFile] = useState(null);
  const [dataConteudoProjecaoFile, setDataConteudoProjecaoFile] =
    useState(null);

  // state outro fields
  const [showOutroEquipamentoField, setShowOutroEquipamentoField] =
    useState(false);
  const [showOutroFinalidadeField, setShowOutroFinalidadeField] =
    useState(false);
  const [showOutroSomFilmagemField, setShowOutroSomFilmagemField] =
    useState(false);
  const [showOutraInstalacaoField, setShowOutraInstalacaoField] =
    useState(false);
  const [showDescrAltoImpactoLocalField, setShowDescrAltoImpactoLocalField] =
    useState(false);
  const [showOutroEquipEsportivoField, setShowOutroEquipEsportivoField] =
    useState(false);
  const [
    showDescrEquipamentoFilmagemField,
    setShowDescrEquipamentoFilmagemField,
  ] = useState(false);
  const [showDescrSomFilmagemField, setShowDescrSomFilmagemField] =
    useState(false);

  // states multi input
  const [horasFilmagemInputs, setHorasFilmagemInputs] = useState([
    { inicio: '', fim: '' },
  ]);
  const [datasFilmagemInputs, setDatasFilmagemInputs] = useState([
    { data_filmagem: '' },
  ]);

  // selectors
  const { data: impactoSelectList } = useSelector(state => state.impactoList);
  const { data: equipamentosSelectList } = useSelector(
    state => state.equipamentoFilmagemList,
  );
  const { data: finalidadeSelectList } = useSelector(
    state => state.finalidadeBaseApoioList,
  );
  const { data: somFilmagemSelectList } = useSelector(
    state => state.somFilmagemList,
  );
  const { data: efeitoEspecialSelectList } = useSelector(
    state => state.efeitoEspecialList,
  );
  const { data: instalacoesList } = useSelector(state => state.instalacoesList);
  const { data: pavimentadaList } = useSelector(state => state.pavimentadaList);
  const { data: equipamentoEsportivoSelectList } = useSelector(
    state => state.equipamentoEsportivoList,
  );

  // effects
  useEffect(() => {
    dispatch(ImpactoListActions.showRequest());
    dispatch(EquipamentoFilmagemListActions.showRequest());
    dispatch(SomFilmagemListActions.showRequest());
    dispatch(EfeitoEspecialListActions.showRequest());
    dispatch(InstalacoesListActions.showRequest());
    dispatch(FinalidadeBaseApoioListActions.showRequest());
    dispatch(PavimentadaListActions.showRequest());
    dispatch(EquipamentoEsportivoListActions.showRequest());
  }, [dispatch]);

  // Busca dados da locação
  const visualizacaoDadosCB = useCallback(async () => {
    if (dadoState?.viewData) {
      setLoading(true);
      const resp = await ApiClient.doRequest({
        uri: `locacao-praca-publica/${dadoState?.viewData?.uuid}`,
        method: ApiClient.GET,
        expectedStatus: 200,
      });

      const respLoc = resp?.data?.data;

      // set temp variables
      const isolarLocalTmp =
        typeof respLoc?.locacao_default.fluxo_area === 'string';

      const blimpadoTmp =
        respLoc?.locacao_default.blimpado === null
          ? null
          : respLoc?.locacao_default.blimpado === 1;

      const geradorPortatilTmp =
        respLoc?.locacao_default.gerador_portatil === null
          ? null
          : respLoc?.locacao_default.gerador_portatil === 1;

      const projecaoLogoTmp =
        typeof respLoc?.locacao_default.porcentagem_projecao === 'number' ||
        typeof respLoc?.locacao_default.area_tempo_projeção === 'string';

      const publicoPrivadoTmp =
        respLoc?.locacao_default?.imovel_publico_privado === null
          ? null
          : respLoc?.locacao_default?.imovel_publico_privado === 1;

      const fileCroqui = respLoc?.locacao_default.files?.filter(
        file => file.name === 'Arquivo Croqui',
      );
      const fileArte = respLoc?.locacao_default.files?.filter(
        file => file.name === 'Relatório de Arte',
      );
      const fileProjecao = respLoc?.locacao_default.files?.filter(
        file => file.name === 'Arquivo Projeção',
      );
      const fileLuz = respLoc?.locacao_default.files?.filter(
        file => file.name === 'Arquivo Iluminação',
      );

      const pontoFixoOptTmp =
        Object.values(respLoc?.ld_instalacoes || []).length > 0 &&
        Object.values(respLoc?.ld_area_pavimentada || []).length > 0;

      const trajetoOptTmp =
        (typeof respLoc?.locacao_default.trajeto === 'string' &&
          fileCroqui?.length > 0) ||
        isolarLocalTmp;

      // set choices buttons
      setPontoFixoTrajeto(pontoFixoOptTmp === true);
      setLocalFilmagem(pontoFixoOptTmp || trajetoOptTmp);
      setIsolarLocal(isolarLocalTmp);
      setIntervencaoArte(
        typeof respLoc?.locacao_default.desc_intervencao_arte === 'string' ||
          fileArte?.length > 0,
      );

      setBlimpado(blimpadoTmp);
      setGeradorPortatil(geradorPortatilTmp);
      setGerador(blimpadoTmp !== null || geradorPortatilTmp !== null);

      setBaseLocal(
        Object.values(respLoc?.locacao_default.ld_finalidade_base_apoio || [])
          .length > 0 ||
          typeof respLoc?.locacao_default.local_base_apoio === 'string' ||
          typeof respLoc?.locacao_default.dimensao_base_apoio === 'string' ||
          typeof respLoc?.locacao_default.quantidade_barracas === 'string',
      );
      setCaptacaoSomDireto(respLoc?.locacao_default.captação_som_direto === 1);
      setSomFilmagem(
        Object.values(respLoc?.locacao_default.ld_som_filmagem || []).length >
          0,
      );
      setDrone(respLoc?.locacao_default.drone === 1);
      setEfeitosEspeciais(
        Object.values(respLoc?.locacao_default.ld_efeitos_especiais || [])
          .length > 0,
      );
      setHaveraAnimais(
        typeof respLoc?.locacao_default.animais_em_cena === 'string',
      );
      setEquipamentoEsportivo(
        Object.values(respLoc?.l_equipamentos_esportivos || []).length > 0,
      );
      setIntervencaoFlora(typeof respLoc?.intervencao_na_flora === 'string');
      setProjecao(
        typeof respLoc?.locacao_default?.estrutura_projecao === 'string' ||
          typeof respLoc?.locacao_default?.instalacao_estrutura_projecao ===
            'string' ||
          publicoPrivadoTmp ||
          projecaoLogoTmp ||
          fileProjecao?.length > 0,
      );
      setPublicoPrivado(publicoPrivadoTmp);
      setProjecaoLogo(projecaoLogoTmp);
      setDesligarLuz(fileLuz?.length > 0);
      setIntervencoesVia(
        Object.values(respLoc?.utilizacao_associadas || []).length > 0,
      );
      setReservasVagas(
        Object.values(respLoc?.locacao_via_externa || []).length > 0,
      );

      // set campos 'multi'
      setDatasFilmagemInputs(
        respLoc?.locacao_default?.dates_locacao_default?.map(
          ({ date, changes_to_approve }) => ({
            data_filmagem: getBrowserTransformDate(date.split(' ')[0], true),
            changes_to_approve,
          }),
        ),
      );

      setHorasFilmagemInputs(
        respLoc?.locacao_default?.hours_locacao_default?.map(
          ({ inicio, fim, changes_to_approve }) => ({
            inicio: inicio.substring(0, 5),
            fim: fim.substring(0, 5),
            changes_to_approve,
          }),
        ),
      );

      // set campos 'Outro'
      setShowOutroEquipamentoField(
        respLoc?.locacao_default?.ld_area_pavimentada?.find(
          equip => equip.name === 'Outro',
        ),
      );
      setShowOutroFinalidadeField(
        respLoc?.locacao_default?.ld_finalidade_base_apoio?.find(
          equip => equip.name === 'outro, descreva',
        ),
      );
      setShowOutroSomFilmagemField(
        respLoc?.locacao_default?.ld_som_filmagem?.find(
          equip => equip.name === 'outro',
        ),
      );
      setShowOutraInstalacaoField(
        respLoc?.ld_instalacoes?.find(equip => equip.name === 'Outros'),
      );
      setShowDescrEquipamentoFilmagemField(
        typeof respLoc?.locacao_default?.descricoes_equipamento_filmagem ===
          'string',
      );
      setShowDescrSomFilmagemField(
        typeof respLoc?.locacao_default?.descricoes_som_filmagem === 'string',
      );
      setShowDescrAltoImpactoLocalField(
        typeof respLoc?.locacao_default?.descr_alto_impacto_local === 'string',
      );

      // set select default values
      formRef.current?.setFieldValue('ld_impacto_uuid', {
        label: respLoc?.locacao_default?.ld_impacto?.name,
        value: respLoc?.locacao_default?.ld_impacto?.uuid,
      });

      formRef.current?.setFieldValue(
        'ld_instalacoes',
        respLoc?.ld_instalacoes?.map(ilef => {
          return {
            label: ilef.name,
            value: ilef.uuid,
          };
        }),
      );

      formRef.current?.setFieldValue(
        'ld_area_pavimentada',
        respLoc?.ld_area_pavimentada?.map(ilef => {
          return {
            label: ilef.name,
            value: ilef.uuid,
          };
        }),
      );

      formRef.current?.setFieldValue(
        'ld_equipamento_filmagem',
        respLoc?.locacao_default?.ld_equipamento_filmagem?.map(lfba => {
          return {
            label: lfba.name,
            value: lfba.uuid,
          };
        }),
      );

      formRef.current?.setFieldValue(
        'ld_finalidade_base_apoio',
        respLoc?.locacao_default?.ld_finalidade_base_apoio?.map(lfba => {
          return {
            label: lfba.name,
            value: lfba.uuid,
          };
        }),
      );

      formRef.current?.setFieldValue(
        'ld_som_filmagem',
        respLoc?.locacao_default?.ld_som_filmagem?.map(ilef => {
          return {
            label: ilef.name,
            value: ilef.uuid,
          };
        }),
      );

      formRef.current?.setFieldValue('ld_efeitos_especiais_uuid', {
        label: respLoc?.locacao_default?.ld_efeitos_especiais?.name,
        value: respLoc?.locacao_default?.ld_efeitos_especiais?.uuid,
      });

      formRef.current?.setFieldValue(
        'l_equipamentos_esportivos',
        respLoc?.l_equipamentos_esportivos?.map(ilef => {
          return {
            label: ilef.name,
            value: ilef.uuid,
          };
        }),
      );

      setResponseLocation(resp?.data?.data);
      setLoading(false);
    }
  }, [dadoState]);

  useEffect(() => {
    visualizacaoDadosCB();
  }, [visualizacaoDadosCB]);

  // handles true/false
  function handleEquipamentoEsportivoTrue(e) {
    e.preventDefault();
    setEquipamentoEsportivo(true);
    setErrorsForm(state => ({
      ...state,
      equipamentoEsportivo: false,
    }));
  }

  function handleEquipamentoEsportivoFalse(e) {
    e.preventDefault();
    setEquipamentoEsportivo(false);
    setErrorsForm(state => ({
      ...state,
      equipamentoEsportivo: false,
    }));
  }

  function handleIntervencaoFloraTrue(e) {
    e.preventDefault();
    setIntervencaoFlora(true);
    setErrorsForm(state => ({
      ...state,
      intervencaoFlora: false,
    }));
  }

  function handleIntervencaoFloraFalse(e) {
    e.preventDefault();
    setIntervencaoFlora(false);
    setErrorsForm(state => ({
      ...state,
      intervencaoFlora: false,
    }));
  }

  function handleLocalFilmagemTrue(e) {
    e.preventDefault();
    setLocalFilmagem(true);
    setErrorsForm(state => ({
      ...state,
      localFilmagem: false,
    }));
  }

  function handleLocalFilmagemFalse(e) {
    e.preventDefault();
    setLocalFilmagem(false);
    setErrorsForm(state => ({
      ...state,
      localFilmagem: false,
    }));
  }

  function handlePontoFixoTrajetoTrue(e) {
    e.preventDefault();
    setPontoFixoTrajeto(true);
    setErrorsForm(state => ({
      ...state,
      pontoFixoTrajeto: false,
    }));
  }

  function handlePontoFixoTrajetoFalse(e) {
    e.preventDefault();
    setPontoFixoTrajeto(false);
    setErrorsForm(state => ({
      ...state,
      pontoFixoTrajeto: false,
    }));
  }

  function handleIsolarLocalTrue(e) {
    e.preventDefault();
    setIsolarLocal(true);
    setErrorsForm(state => ({
      ...state,
      isolarLocal: false,
    }));
  }

  function handleIsolarLocalFalse(e) {
    e.preventDefault();
    setIsolarLocal(false);
    setErrorsForm(state => ({
      ...state,
      isolarLocal: false,
    }));
  }

  function handleIntervencaoArteTrue(e) {
    e.preventDefault();
    setIntervencaoArte(true);
    setErrorsForm(state => ({
      ...state,
      intervencaoArte: false,
    }));
  }

  function handleIntervencaoArteFalse(e) {
    e.preventDefault();
    setIntervencaoArte(false);
    setErrorsForm(state => ({
      ...state,
      intervencaoArte: false,
    }));
  }

  function handleGeradorTrue(e) {
    e.preventDefault();
    setGerador(true);
    setErrorsForm(state => ({
      ...state,
      gerador: false,
    }));
  }

  function handleGeradorFalse(e) {
    e.preventDefault();
    setGerador(false);
    setErrorsForm(state => ({
      ...state,
      gerador: false,
    }));
  }

  function handleGeradorPortatilTrue(e) {
    e.preventDefault();
    setGeradorPortatil(true);
    setErrorsForm(state => ({
      ...state,
      geradorPortatil: false,
    }));
  }

  function handleGeradorPortatilFalse(e) {
    e.preventDefault();
    setGeradorPortatil(false);
    setErrorsForm(state => ({
      ...state,
      geradorPortatil: false,
    }));
  }

  function handleBlimpadorTrue(e) {
    e.preventDefault();
    setBlimpado(true);
    setErrorsForm(state => ({
      ...state,
      blimpado: false,
    }));
  }

  function handleBlimpadorFalse(e) {
    e.preventDefault();
    setBlimpado(false);
    setErrorsForm(state => ({
      ...state,
      blimpado: false,
    }));
  }

  function handleBaseLocalTrue(e) {
    e.preventDefault(e);
    setBaseLocal(true);
    setErrorsForm(state => ({
      ...state,
      baseLocal: false,
    }));
  }

  function handleBaseLocalFalse(e) {
    e.preventDefault(e);
    setBaseLocal(false);
    setErrorsForm(state => ({
      ...state,
      baseLocal: false,
    }));
  }

  function handleCaptacaoSomDiretoTrue(e) {
    e.preventDefault();
    setCaptacaoSomDireto(true);
    setErrorsForm(state => ({
      ...state,
      captacaoSomDireto: false,
    }));
  }

  function handleCaptacaoSomDiretoFalse(e) {
    e.preventDefault();
    setCaptacaoSomDireto(false);
    setErrorsForm(state => ({
      ...state,
      captacaoSomDireto: false,
    }));
  }

  function handleSomFilmagemTrue(e) {
    e.preventDefault(e);
    setSomFilmagem(true);
    setErrorsForm(state => ({
      ...state,
      somFilmagem: false,
    }));
  }

  function handleSomFilmagemFalse(e) {
    e.preventDefault(e);
    setSomFilmagem(false);
    setErrorsForm(state => ({
      ...state,
      somFilmagem: false,
    }));
  }

  function handleEfeitosEspeciaisTrue(e) {
    e.preventDefault(e);
    setEfeitosEspeciais(true);
    setErrorsForm(state => ({
      ...state,
      efeitosEspeciais: false,
    }));
  }

  function handleEfeitosEspeciaisFalse(e) {
    e.preventDefault(e);
    setEfeitosEspeciais(false);
    setErrorsForm(state => ({
      ...state,
      efeitosEspeciais: false,
    }));
  }

  function handleHaveraAnimaisTrue(e) {
    e.preventDefault(e);
    setHaveraAnimais(true);
    setErrorsForm(state => ({
      ...state,
      haveraAnimais: false,
    }));
  }

  function handleHaveraAnimaisFalse(e) {
    e.preventDefault(e);
    setHaveraAnimais(false);
    setErrorsForm(state => ({
      ...state,
      haveraAnimais: false,
    }));
  }

  function handleDroneTue(e) {
    e.preventDefault();
    setDrone(true);
    setErrorsForm(state => ({
      ...state,
      drone: false,
    }));
  }

  function handleDroneFalse(e) {
    e.preventDefault();
    setDrone(false);
    setErrorsForm(state => ({
      ...state,
      drone: false,
    }));
  }

  function handleProjecaoTrue(e) {
    e.preventDefault();
    setProjecao(true);
    setErrorsForm(state => ({
      ...state,
      projecao: false,
    }));
  }

  function handleProjecaoFalse(e) {
    e.preventDefault();
    setProjecao(false);
    setErrorsForm(state => ({
      ...state,
      projecao: false,
    }));
  }

  function handlePublicoPrivadoTrue(e) {
    e.preventDefault();
    setPublicoPrivado(true);
    setErrorsForm(state => ({
      ...state,
      publicoPrivado: false,
    }));
  }

  function handlePublicoPrivadoFalse(e) {
    e.preventDefault();
    setPublicoPrivado(false);
    setErrorsForm(state => ({
      ...state,
      publicoPrivado: false,
    }));
  }

  function handleDesligarLuzTrue(e) {
    e.preventDefault(e);
    setDesligarLuz(true);
    setErrorsForm(state => ({
      ...state,
      desligarLuz: false,
    }));
  }

  function handleDesligarLuzFalse(e) {
    e.preventDefault(e);
    setDesligarLuz(false);
    setErrorsForm(state => ({
      ...state,
      desligarLuz: false,
    }));
  }

  function handleProjecaoLogoTrue(e) {
    e.preventDefault();
    setProjecaoLogo(true);
    setErrorsForm(state => ({
      ...state,
      projecaoLogo: false,
    }));
  }

  function handleProjecaoLogoFalse(e) {
    e.preventDefault();
    setProjecaoLogo(false);
    setErrorsForm(state => ({
      ...state,
      projecaoLogo: false,
    }));
  }

  function handleIntervencoesViaTrue(e) {
    e.preventDefault(e);
    setIntervencoesVia(true);
    setErrorsForm(state => ({
      ...state,
      intervencoesVia: false,
    }));
  }

  function handleIntervencoesViaFalse(e) {
    e.preventDefault(e);
    setIntervencoesVia(false);
    setErrorsForm(state => ({
      ...state,
      intervencoesVia: false,
    }));
  }

  function handleReservasVagasTrue(e) {
    e.preventDefault(e);
    setReservasVagas(true);
    setErrorsForm(state => ({
      ...state,
      reservasVagas: false,
    }));
  }

  function handleReservasVagasFalse(e) {
    e.preventDefault(e);
    setReservasVagas(false);
    setErrorsForm(state => ({
      ...state,
      reservasVagas: false,
    }));
  }

  // handles files
  function handleCroquiFile() {
    return croquiFileRef.current.click();
  }

  function handleRelatorioArteFile() {
    return relatorioArteRef.current.click();
  }

  function handleConteudoProjecaoFile() {
    return conteudoProjecaoRef.current.click();
  }

  function handleIluminacaoFile() {
    return iluminacaoFileRef.current.click();
  }

  const convertBase64 = arquivo => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(arquivo);

      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.onerror = error => {
        reject(error);
      };
    });
  };
  // Verification files
  let fileCroqui = [];
  let fileArte = [];
  let fileProjecao = [];
  let fileLuz = [];

  // Filter files
  fileCroqui = responseLocation?.locacao_default.files?.filter(
    file => file.name === 'Arquivo Croqui',
  );
  fileArte = responseLocation?.locacao_default.files?.filter(
    file => file.name === 'Relatório de Arte',
  );
  fileProjecao = responseLocation?.locacao_default.files?.filter(
    file => file.name === 'Arquivo Projeção',
  );
  fileLuz = responseLocation?.locacao_default.files?.filter(
    file => file.name === 'Arquivo Iluminação',
  );

  async function handleFileChange(event) {
    event.preventDefault();
    const { name } = event.target;

    const file = event.target.files[0];
    const base64 = await convertBase64(file);

    if (name === 'croqui_file') {
      setCroquiFile(base64.split('base64,'));
      setDataCroquiFile(file);
      setErrorsForm(state => ({
        ...state,
        croquiFile: false,
      }));
    }

    if (name === 'relatorio_arte_file') {
      setRelatorioArteFile(base64.split('base64,'));
      setDataRelatorioArteFile(file);
      setErrorsForm(state => ({
        ...state,
        relatorioArteFile: false,
      }));
    }

    if (name === 'conteudo_projecao_file') {
      setConteudoProjecaoFile(base64.split('base64,'));
      setDataConteudoProjecaoFile(file);
      setErrorsForm(state => ({
        ...state,
        conteudoProjecaoFile: false,
      }));
    }

    if (name === 'iluminacao_file') {
      setIluminacaoFile(base64.split('base64,'));
      setDataIluminacaoFile(file);
      setErrorsForm(state => ({
        ...state,
        iluminacaoFile: false,
      }));
    }

    setFormData(state => ({ ...state, [name]: base64.split('base64,')[1] }));
  }

  // handles multi select
  function handleMultiSelectEquipEsportivos(e) {
    setShowOutroEquipEsportivoField(!!e?.find(x => x.label === 'Outro'));
    setFormData(state => ({
      ...state,
      l_equipamentos_esportivos: Array.isArray(e) ? e.map(x => x.value) : [],
    }));
  }

  function handleMultiSelectEquipamentos(e) {
    setShowOutroEquipamentoField(!!e?.find(x => x.label === 'Outro'));
    setShowDescrEquipamentoFilmagemField(
      e?.some(equip => equip.label?.includes(':')) || false,
    );
    setFormData(state => ({
      ...state,
      ld_equipamento_filmagem: Array.isArray(e) ? e.map(x => x.value) : [],
    }));
  }

  function handleMultiSelectFinalidades(e) {
    setShowOutroFinalidadeField(!!e?.find(x => x.label === 'outro, descreva'));

    setFormData(state => ({
      ...state,
      ld_finalidade_base_apoio: Array.isArray(e) ? e.map(x => x.value) : [],
    }));
  }

  function handleMultiSelectSomFilmagem(e) {
    setShowOutroSomFilmagemField(!!e?.find(x => x.label === 'outro'));
    setShowDescrSomFilmagemField(
      e?.some(equip => equip.label?.includes('descrever')) || false,
    );
    setFormData(state => ({
      ...state,
      ld_som_filmagem: Array.isArray(e) ? e.map(x => x.value) : [],
    }));
  }

  function handleMultiSelectInstalacao(e) {
    setShowOutraInstalacaoField(!!e?.find(x => x.label === 'Outros'));

    setFormData(state => ({
      ...state,
      ld_instalacoes: Array.isArray(e) ? e.map(x => x.value) : [],
    }));
  }

  function handleMultiSelectAreaPavimentada(e) {
    setFormData(state => ({
      ...state,
      ld_area_pavimentada: Array.isArray(e) ? e.map(x => x.value) : [],
    }));
  }

  function handleChange(event) {
    const { name, value } = event.target;
    setFormData(state => ({ ...state, [name]: value }));
  }

  function handleSelectChange(name, option) {
    const value = option ? option.value : null;
    setFormData(state => ({ ...state, [name]: value }));
  }

  async function handleValidationFields(data) {
    try {
      formRef.current.setErrors({});
      const defaultMsg = 'Obrigatório';

      const schema = Yup.object().shape({
        street: Yup.string().typeError(defaultMsg).required(defaultMsg),
        ld_impacto_uuid: Yup.string()
          .typeError(defaultMsg)
          .required(defaultMsg),
        descr_alto_impacto_local: Yup.string()
          .typeError(defaultMsg)
          .test(
            'alto-impacto-local-selecionado',
            defaultMsg,
            value =>
              !(
                showDescrAltoImpactoLocalField === true &&
                (value?.length <= 0 || !value)
              ),
          ),
        tamanho_equipe_tecnica: Yup.string()
          .typeError(defaultMsg)
          .required(defaultMsg),
        tamanho_do_elenco: Yup.string()
          .typeError(defaultMsg)
          .required(defaultMsg),
        descricao_cena: Yup.string().typeError(defaultMsg).required(defaultMsg),
        trajeto: Yup.string()
          .typeError(defaultMsg)
          .test(
            'local-filmagem-selecionado',
            defaultMsg,
            value =>
              !(
                localFilmagem &&
                pontoFixoTrajeto === false &&
                (!value || value?.length <= 0)
              ),
          ),
        ld_instalacoes: Yup.array()
          .of(Yup.string().typeError(defaultMsg).required(defaultMsg))
          .typeError(defaultMsg)
          .test(
            'ponto-fixo-selecionado',
            defaultMsg,
            value =>
              !(
                localFilmagem &&
                pontoFixoTrajeto === true &&
                (value || []).length <= 0
              ),
          ),
        outra_instalacao: Yup.string()
          .typeError(defaultMsg)
          .test(
            'local-filmagem-selecionado',
            defaultMsg,
            value =>
              !(
                localFilmagem &&
                pontoFixoTrajeto === true &&
                showOutraInstalacaoField === true &&
                (!value || value?.length <= 0)
              ),
          ),
        ld_area_pavimentada: Yup.array()
          .of(Yup.string().typeError(defaultMsg).required(defaultMsg))
          .typeError(defaultMsg)
          .test(
            'ponto-fixo-selecionado',
            defaultMsg,
            value =>
              !(
                localFilmagem &&
                pontoFixoTrajeto === true &&
                (value || []).length <= 0
              ),
          ),
        fluxo_area: Yup.string()
          .typeError(defaultMsg)
          .test(
            'isolar-local-selecionado',
            defaultMsg,
            value =>
              !(
                localFilmagem &&
                isolarLocal === true &&
                (!value || value?.length <= 0)
              ),
          ),
        desc_intervencao_arte: Yup.string()
          .typeError(defaultMsg)
          .test(
            'intervencao-arte-selecionado',
            defaultMsg,
            value =>
              !(intervencaoArte === true && (value?.length <= 0 || !value)),
          ),
        ld_equipamento_filmagem: Yup.array()
          .of(Yup.string().typeError(defaultMsg).required(defaultMsg))
          .typeError(defaultMsg)
          .test(
            'ld-equipamento-filmagem-selecionado',
            defaultMsg,
            value => !(!value || value?.length <= 0),
          ),
        outro_equipamento: Yup.string()
          .typeError(defaultMsg)
          .test(
            'outro-equipamento-selecionado',
            defaultMsg,
            value =>
              !(
                showOutroEquipamentoField === true &&
                (value?.length <= 0 || !value)
              ),
          ),
        descricoes_equipamento_filmagem: Yup.string()
          .typeError(defaultMsg)
          .test(
            'descricoes-equipamento-filmagem-selecionado',
            defaultMsg,
            value =>
              !(
                showDescrEquipamentoFilmagemField === true &&
                (value?.length <= 0 || !value)
              ),
          ),
        veiculo_gerador: Yup.string()
          .typeError(defaultMsg)
          .test(
            'veiculo-gerador-selecionado',
            defaultMsg,
            value =>
              !(geradorPortatil === false && (value?.length <= 0 || !value)),
          ),
        local_gerador: Yup.string()
          .typeError(defaultMsg)
          .test(
            'gerador-selecionado',
            defaultMsg,
            value => !(gerador === true && value?.length <= 0),
          ),
        intervencao_na_flora: Yup.string()
          .typeError(defaultMsg)
          .test(
            'intervencao-flora-selecionado',
            defaultMsg,
            value =>
              !(intervencaoFlora === true && (value?.length <= 0 || !value)),
          ),
        ld_finalidade_base_apoio: Yup.array()
          .of(Yup.string().typeError(defaultMsg).required(defaultMsg))
          .typeError(defaultMsg)
          .test(
            'base-local-selecionado',
            defaultMsg,
            value => !(baseLocal === true && (value?.length <= 0 || !value)),
          ),
        outro_finalidade: Yup.string()
          .typeError(defaultMsg)
          .test(
            'outro-finalidade-selecionado',
            defaultMsg,
            value =>
              !(
                baseLocal === true &&
                showOutroFinalidadeField === true &&
                (value?.length <= 0 || !value)
              ),
          ),
        local_base_apoio: Yup.string()
          .typeError(defaultMsg)
          .test(
            'base-local-selecionado',
            defaultMsg,
            value => !(baseLocal === true && (value?.length <= 0 || !value)),
          ),
        ld_som_filmagem: Yup.array()
          .of(Yup.string().typeError(defaultMsg).required(defaultMsg))
          .typeError(defaultMsg)
          .test(
            'som-filmagem-selecionado',
            defaultMsg,
            value => !(somFilmagem === true && (value?.length <= 0 || !value)),
          ),
        descricoes_som_filmagem: Yup.string()
          .typeError(defaultMsg)
          .test(
            'descricoes-som-filmagem-selecionado',
            defaultMsg,
            value =>
              !(
                somFilmagem &&
                showDescrSomFilmagemField === true &&
                (value?.length <= 0 || !value)
              ),
          ),
        outro_som_filmagem: Yup.string()
          .typeError(defaultMsg)
          .test(
            'outro-som-filmagem-selecionado',
            defaultMsg,
            value =>
              !(
                somFilmagem &&
                showOutroSomFilmagemField === true &&
                (value?.length <= 0 || !value)
              ),
          ),
        ld_efeitos_especiais_uuid: Yup.string()
          .typeError(defaultMsg)
          .test(
            'efeitos-especiais-selecionado',
            defaultMsg,
            value =>
              !(efeitosEspeciais === true && (value?.length <= 0 || !value)),
          ),
        descricao_animais: Yup.string()
          .typeError(defaultMsg)
          .test(
            'havera-animais-selecionado',
            defaultMsg,
            value =>
              !(haveraAnimais === true && (value?.length <= 0 || !value)),
          ),
        l_equipamentos_esportivos: Yup.array()
          .of(Yup.string().typeError(defaultMsg).required(defaultMsg))
          .typeError(defaultMsg)
          .test(
            'ld-equipamento-filmagem-selecionado',
            defaultMsg,
            value =>
              !(
                equipamentoEsportivo === true &&
                (value?.length <= 0 || !value)
              ),
          ),
        outro_equipamento_esportivo: Yup.string()
          .typeError(defaultMsg)
          .test(
            'outro-equipamento-esportivo-selecionado',
            defaultMsg,
            value =>
              !(
                equipamentoEsportivo &&
                showOutroEquipEsportivoField === true &&
                (value?.length <= 0 || !value)
              ),
          ),
        estrutura_projecao: Yup.string()
          .typeError(defaultMsg)
          .test(
            'projecao-selecionado',
            defaultMsg,
            value => !(projecao === true && (value?.length <= 0 || !value)),
          ),
        instalacao_estrutura_projecao: Yup.string()
          .typeError(defaultMsg)
          .test(
            'projecao-selecionado',
            defaultMsg,
            value => !(projecao === true && (value?.length <= 0 || !value)),
          ),
        porcentagem_projecao: Yup.string()
          .typeError(defaultMsg)
          .test(
            'projecao-logo-selecionado',
            defaultMsg,
            value =>
              !(
                projecao &&
                projecaoLogo === true &&
                (value?.length <= 0 || !value)
              ),
          ),
        area_tempo_projeção: Yup.string()
          .typeError(defaultMsg)
          .test(
            'projecao-logo-selecionado',
            defaultMsg,
            value =>
              !(
                projecao &&
                projecaoLogo === true &&
                (value?.length <= 0 || !value)
              ),
          ),
      });

      await schema.validate(data, {
        abortEarly: false,
      });

      if (!validDateArray(datasFilmagemInputs, 'data_filmagem')) {
        await showModalMessage({
          type: 'error',
          text: 'Por favor, informe apenas datas válidas!',
        });
        return false;
      }

      if (!validHourArray(horasFilmagemInputs, 'inicio', 'fim')) {
        await showModalMessage({
          type: 'error',
          text: 'Por favor, informe apenas horas válidas!',
        });
        return false;
      }

      // Campos 'choice button' não selecionados
      if (localFilmagem === null) {
        await showModalMessage({
          type: 'error',
          text: 'Local de filmagem não foi informado!',
        });
        setErrorsForm(state => ({
          ...state,
          localFilmagem: true,
        }));
        return false;
      }

      if (localFilmagem) {
        if (pontoFixoTrajeto === null) {
          await showModalMessage({
            type: 'error',
            text: 'Ponto Fixo/Trajeto não foi informado!',
          });
          setErrorsForm(state => ({
            ...state,
            pontoFixoTrajeto: true,
          }));
          return false;
        }

        if (!pontoFixoTrajeto && isolarLocal === null) {
          await showModalMessage({
            type: 'error',
            text: 'Isolar Local não foi informado!',
          });
          setErrorsForm(state => ({
            ...state,
            isolarLocal: true,
          }));
          return false;
        }

        if (!pontoFixoTrajeto && croquiFile === null) {
          await showModalMessage({
            type: 'error',
            text: 'Arquivo Croqui ainda não foi enviado!',
          });
          setErrorsForm(state => ({
            ...state,
            croquiFile: true,
          }));
          return false;
        }
      }

      if (intervencaoArte === null) {
        await showModalMessage({
          type: 'error',
          text: 'Intervenção de arte não foi informado!',
        });
        setErrorsForm(state => ({
          ...state,
          intervencaoArte: true,
        }));
        return false;
      }

      if (intervencaoArte && relatorioArteFile === null) {
        await showModalMessage({
          type: 'error',
          text: 'Arquivo Relatório Arte ainda não foi enviado!',
        });
        setErrorsForm(state => ({
          ...state,
          relatorioArteFile: true,
        }));
        return false;
      }

      if (gerador === null) {
        await showModalMessage({
          type: 'error',
          text: 'Gerador não foi informado!',
        });
        setErrorsForm(state => ({
          ...state,
          gerador: true,
        }));
        return false;
      }

      if (gerador) {
        if (blimpado === null) {
          await showModalMessage({
            type: 'error',
            text: 'Blimpado não foi informado!',
          });
          setErrorsForm(state => ({
            ...state,
            blimpado: true,
          }));
          return false;
        }

        if (geradorPortatil === null) {
          await showModalMessage({
            type: 'error',
            text: 'Gerador portátil não foi informado!',
          });
          setErrorsForm(state => ({
            ...state,
            geradorPortatil: true,
          }));
          return false;
        }
      }

      if (baseLocal === null) {
        await showModalMessage({
          type: 'error',
          text: 'Base de Apoio no local não foi informado!',
        });
        setErrorsForm(state => ({
          ...state,
          baseLocal: true,
        }));
        return false;
      }

      if (captacaoSomDireto === null) {
        await showModalMessage({
          type: 'error',
          text: 'Captação de Som direto não foi informado!',
        });
        setErrorsForm(state => ({
          ...state,
          captacaoSomDireto: true,
        }));
        return false;
      }

      if (somFilmagem === null) {
        await showModalMessage({
          type: 'error',
          text: 'Som na filmagem não foi informado!',
        });
        setErrorsForm(state => ({
          ...state,
          somFilmagem: true,
        }));
        return false;
      }

      if (drone === null) {
        await showModalMessage({
          type: 'error',
          text: 'Drone não foi informado!',
        });
        setErrorsForm(state => ({
          ...state,
          drone: true,
        }));
        return false;
      }

      if (efeitosEspeciais === null) {
        await showModalMessage({
          type: 'error',
          text: 'Efeitos Especiais não foi informado!',
        });
        setErrorsForm(state => ({
          ...state,
          efeitosEspeciais: true,
        }));
        return false;
      }

      if (haveraAnimais === null) {
        await showModalMessage({
          type: 'error',
          text: 'Animais de cena não foi informado!',
        });
        setErrorsForm(state => ({
          ...state,
          haveraAnimais: true,
        }));
        return false;
      }

      if (equipamentoEsportivo === null) {
        await showModalMessage({
          type: 'error',
          text: 'Equipamentos esportivos não foi informado!',
        });
        setErrorsForm(state => ({
          ...state,
          equipamentoEsportivo: true,
        }));
        return false;
      }

      if (intervencaoFlora === null) {
        await showModalMessage({
          type: 'error',
          text: "Opção 'Intervencao Flora' não foi informado!",
        });
        setErrorsForm(state => ({
          ...state,
          intervencaoFlora: true,
        }));
        return false;
      }

      if (projecao === null) {
        await showModalMessage({
          type: 'error',
          text: 'Projeção visível não foi informado!',
        });
        setErrorsForm(state => ({
          ...state,
          projecao: true,
        }));
        return false;
      }

      if (projecao) {
        if (conteudoProjecaoFile === null) {
          await showModalMessage({
            type: 'error',
            text: 'Arquivo Conteúdo da Projeção ainda não foi enviado!',
          });
          setErrorsForm(state => ({
            ...state,
            conteudoProjecaoFile: true,
          }));
          return false;
        }

        if (publicoPrivado === null) {
          await showModalMessage({
            type: 'error',
            text: 'Imóvel Público/Privado não foi informado!',
          });
          setErrorsForm(state => ({
            ...state,
            publicoPrivado: true,
          }));
          return false;
        }

        if (projecaoLogo === null) {
          await showModalMessage({
            type: 'error',
            text: 'Exibição de logomarca não foi informado!',
          });
          setErrorsForm(state => ({
            ...state,
            projecaoLogo: true,
          }));
          return false;
        }
      }

      if (desligarLuz === null) {
        await showModalMessage({
          type: 'error',
          text: 'Desligamento de iluminação no local não foi informado!',
        });
        setErrorsForm(state => ({
          ...state,
          desligarLuz: true,
        }));
        return false;
      }

      if (desligarLuz && iluminacaoFile === null) {
        await showModalMessage({
          type: 'error',
          text: 'Arquivo de iluminação de arte ainda não foi enviado!',
        });
        setErrorsForm(state => ({
          ...state,
          iluminacaoFile: true,
        }));
        return false;
      }

      if (intervencoesVia === null) {
        await showModalMessage({
          type: 'error',
          text: 'Intervenções na Via não foi informado!',
        });
        setErrorsForm(state => ({
          ...state,
          intervencoesVia: true,
        }));
        return false;
      }

      if (reservasVagas === null) {
        await showModalMessage({
          type: 'error',
          text: 'Reservas de vagas não foi informado!',
        });
        setErrorsForm(state => ({
          ...state,
          reservasVagas: true,
        }));
        return false;
      }
    } catch (err) {
      await showModalMessage({
        type: 'error',
        text: 'Preencha os campos obrigatórios!',
      });
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        formRef.current.setErrors(validationErrors);
      }
      return false;
    }
    return true;
  }

  function formatDefaultData(data) {
    // dados já exibidos sem condicoes
    const dataNaoCondicional = omitEmpty({
      ld_impacto_uuid: data?.ld_impacto_uuid,
      ld_equipamento_filmagem: data?.ld_equipamento_filmagem,
      tamanho_equipe_tecnica: data?.tamanho_equipe_tecnica,
      tamanho_do_elenco: data?.tamanho_do_elenco,
      descricao_cena: data?.descricao_cena,
      especificidades: data?.especificidades,
    });

    // dados de choices
    const dataPontoFixoTrajeto =
      localFilmagem && pontoFixoTrajeto
        ? {
            trajeto: null,
            croqui_base64: null,
          }
        : {
            trajeto: data?.trajeto,
            croqui_base64: data?.croqui_file,
          };

    const dataIsolarLocal = {
      fluxo_area: localFilmagem && isolarLocal ? data?.fluxo_area : null,
    };

    const dataIntervencaoArte = intervencaoArte
      ? {
          desc_intervencao_arte: data?.desc_intervencao_arte,
          relat_arte_base64: data?.relatorio_arte_file,
        }
      : { desc_intervencao_arte: null, relat_arte_base64: null };

    const dataGerador = gerador
      ? {
          blimpado,
          gerador_portatil: geradorPortatil,
          veiculo_gerador: !geradorPortatil ? data?.veiculo_gerador : null,
        }
      : { blimpado: null, gerador_portatil: null, veiculo_gerador: null };

    const dataBaseLocal = baseLocal
      ? {
          ld_finalidade_base_apoio: data?.ld_finalidade_base_apoio,
          local_base_apoio: data?.local_base_apoio,
          dimensao_base_apoio: data?.dimensao_base_apoio,
          quantidade_barracas: data?.quantidade_barracas,
        }
      : {
          ld_finalidade_base_apoio: null,
          local_base_apoio: null,
          dimensao_base_apoio: null,
          quantidade_barracas: null,
        };

    const dataCaptacaoSomDireto = { captação_som_direto: captacaoSomDireto };

    const dataSomFilmagem = {
      ld_som_filmagem: somFilmagem ? data?.ld_som_filmagem : null,
    };

    const dataDrone = { drone };

    const dataEfeitosEspeciais = {
      ld_efeitos_especiais_uuid: efeitosEspeciais
        ? data?.ld_efeitos_especiais_uuid
        : null,
    };

    const dataHaveraAnimais = {
      animais_em_cena: haveraAnimais ? data?.descricao_animais : null,
    };

    const dataProjecao = projecao
      ? {
          estrutura_projecao: data?.estrutura_projecao,
          instalacao_estrutura_projecao: data?.instalacao_estrutura_projecao,
          imovel_publico_privado: publicoPrivado,
          projecao_base64: data?.conteudo_projecao_file,
        }
      : {
          estrutura_projecao: null,
          instalacao_estrutura_projecao: null,
          imovel_publico_privado: null,
          projecao_base64: null,
        };

    const dataProjecaoLogo =
      projecao && projecaoLogo
        ? {
            porcentagem_projecao: +data?.porcentagem_projecao || undefined,
            area_tempo_projeção: data?.area_tempo_projeção,
          }
        : { porcentagem_projecao: null, area_tempo_projeção: null };

    const dataIluminacao = {
      iluminacao_base64: desligarLuz ? data?.iluminacao_file : null,
    };

    // dados de campos exibidos condicionalmente
    const dataDescrAltoImpactoLocal = {
      descr_alto_impacto_local: showDescrAltoImpactoLocalField
        ? data?.descr_alto_impacto_local
        : null,
    };

    const dataDescrEquipamentoFilmagem = {
      descricoes_equipamento_filmagem: showDescrEquipamentoFilmagemField
        ? data?.descricoes_equipamento_filmagem
        : null,
    };

    const dataDescrSomFilmagem = {
      descricoes_som_filmagem:
        somFilmagem && showDescrSomFilmagemField
          ? data?.descricoes_som_filmagem
          : null,
    };

    const dataOutroEquipamento = {
      outro_equipamento: showOutroEquipamentoField
        ? data?.outro_equipamento
        : null,
    };

    const dataOutroFinalidade = {
      outro_finalidade:
        baseLocal && showOutroFinalidadeField ? data?.outro_finalidade : null,
    };

    const dataOutroSomFilmagem = {
      outro_som_filmagem:
        somFilmagem && showOutroSomFilmagemField
          ? data?.outro_som_filmagem
          : null,
    };

    // format datas filmagem
    const datasFilmagem = datasFilmagemInputs
      .filter(item => typeof item === 'object')
      .map(item => getBrowserTransformDate(item.data_filmagem));

    return Object.assign(
      dataNaoCondicional,
      { dates: datasFilmagem },
      { hours: horasFilmagemInputs },
      dataPontoFixoTrajeto,
      dataIsolarLocal,
      dataIntervencaoArte,
      dataGerador,
      dataBaseLocal,
      dataCaptacaoSomDireto,
      dataSomFilmagem,
      dataDrone,
      dataEfeitosEspeciais,
      dataHaveraAnimais,
      dataProjecao,
      dataProjecaoLogo,
      dataIluminacao,
      dataDescrAltoImpactoLocal,
      dataDescrEquipamentoFilmagem,
      dataOutroEquipamento,
      dataOutroFinalidade,
      dataDescrSomFilmagem,
      dataOutroSomFilmagem,
    );
  }

  function formatEspecificaData(data) {
    // dados já exibidos sem condicoes
    const dataNaoCondicional = omitEmpty({
      titulo_locacao: data?.titulo_locacao,
      street: data?.street,
    });

    // dados de choices
    const dataPontoFixoTrajeto =
      localFilmagem && pontoFixoTrajeto
        ? {
            ld_instalacoes: data?.ld_instalacoes,
            ld_area_pavimentada: data?.ld_area_pavimentada,
          }
        : {
            ld_instalacoes: null,
            ld_area_pavimentada: null,
          };

    const dataGerador = { local_gerador: gerador ? data?.local_gerador : null };

    const dataEquipamentoEsportivo = {
      l_equipamentos_esportivos: equipamentoEsportivo
        ? data?.l_equipamentos_esportivos
        : null,
    };

    const dataIntervencaoFlora = {
      intervencao_na_flora: intervencaoFlora
        ? data?.intervencao_na_flora
        : null,
    };

    // dados de campos exibidos condicionalmente
    const dataOutraInstalacao = {
      outra_instalacao:
        localFilmagem && pontoFixoTrajeto && showOutraInstalacaoField
          ? data?.outra_instalacao
          : null,
    };

    const dataOutroEquipEsportivo = {
      outro_equipamento_esportivo:
        equipamentoEsportivo && showOutroEquipEsportivoField
          ? data?.outro_equipamento_esportivo
          : null,
    };

    return Object.assign(
      dataNaoCondicional,
      dataPontoFixoTrajeto,
      dataGerador,
      dataIntervencaoFlora,
      dataEquipamentoEsportivo,
      dataOutraInstalacao,
      dataOutroEquipEsportivo,
    );
  }

  async function handleSubmit(data) {
    // files
    data.croqui_file = formData?.croqui_file;
    data.relatorio_arte_file = formData?.relatorio_arte_file;
    data.iluminacao_file = formData?.iluminacao_file;
    data.conteudo_projecao_file = formData?.conteudo_projecao_file;

    // selects
    data.ld_equipamento_filmagem = formData?.ld_equipamento_filmagem;
    data.ld_instalacoes = formData?.ld_instalacoes;
    data.ld_area_pavimentada = formData?.ld_area_pavimentada;
    data.ld_finalidade_base_apoio = formData?.ld_finalidade_base_apoio;
    data.ld_som_filmagem = formData?.ld_som_filmagem;
    data.l_equipamentos_esportivos = formData?.l_equipamentos_esportivos;

    try {
      if (!(await handleValidationFields(data))) {
        return;
      }

      const defaultData = formatDefaultData(data);
      const especificaData = formatEspecificaData(data);

      setLoading(true);

      const responseDefault = await ApiClient.doRequest({
        uri: 'locacao-default',
        method: ApiClient.POST,
        body: defaultData,
        expectedStatus: 201,
      });

      await ApiClient.doRequest({
        uri: 'locacao-praca-publica',
        method: ApiClient.POST,
        body: Object.assign(
          especificaData,
          { work_uuid: dadoState?.uuid },
          { locacao_default_uuid: responseDefault?.data?.data?.uuid },
        ),
        expectedStatus: 201,
      });

      setLoading(false);

      await showModalMessage({
        type: 'success',
        title: 'Praças',
        text: 'Locação gravada com sucesso',
      });

      // conclusao
      const redirections = [
        {
          url: '/solicitacao-nova-locacao/locacao-utilizacao-via',
          next: intervencoesVia,
        },
        {
          url: '/solicitacao-nova-locacao/reservas-vagas-vinculado',
          next: reservasVagas,
        },
      ].filter(({ next }) => !!next);

      const [nextRedirect] = redirections;

      if (nextRedirect) {
        history.replace({
          pathname: nextRedirect.url,
          state: {
            uuid: dadoState?.uuid,
            redirections: redirections.filter(
              ({ url }) => url !== nextRedirect.url,
            ),
          },
        });
      } else {
        history.push('/home-user');
      }
    } catch (err) {
      setLoading(false);
      await showModalMessage({
        type: 'error',
        title: 'Praças',
        text: err.message,
      });
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        formRef.current.setErrors(validationErrors);
      }
    }
  }

  function renderLocacao() {
    if (dadoState?.viewData && !loading && !responseLocation) {
      return (
        <PageContainer style={{ height: '100%' }}>
          <PageContent>
            <WhiteBox column jCenter aCenter marginBottom="30px">
              <h3 style={{ color: '#828282' }}>Nenhuma Locação encontrada</h3>
            </WhiteBox>
          </PageContent>
        </PageContainer>
      );
    }

    return (
      <>
        {loading && (
          <MainLoading loading={loading}>
            <h3>Processando Informações</h3>
            <BiLoaderAlt size={32} color="#ffffff" className="icon-spin" />
          </MainLoading>
        )}
        <PageContainer>
          <PageContent>
            <Form ref={formRef} onSubmit={handleSubmit}>
              <WhiteBox column jCenter aCenter marginBottom="30px">
                {!isAdminRequest && (
                  <>
                    <LocacaoDocs
                      excludes={['precosFilmagensEquipamentosPublicos']}
                    />
                  </>
                )}

                {responseLocation?.protocol && (
                  <BoxHeader>
                    <span
                      className="boxText"
                      style={{ color: '#828282' }}
                    >{`[ Número: ${responseLocation?.protocol} ]`}</span>
                  </BoxHeader>
                )}

                <Wrap>
                  <LimiterInputWidth w50>
                    <Input
                      type="text"
                      name="titulo_locacao"
                      label="Nome da Locação (Opcional)"
                      onChange={handleChange}
                      defaultValue={
                        dadoState?.viewData && responseLocation?.titulo_locacao
                      }
                      disabled={dadoState?.viewData && true}
                      questionTooltip="Para controle interno das produções, é possível adicionar o nome da locação, como por exemplo: Casa da Personagem Principal. Esse controle não constará em pedidos e documentações oficiais, e é somente um facilitador em projetos de grande porte."
                    />
                  </LimiterInputWidth>
                </Wrap>
                <Wrap>
                  <Input
                    type="text"
                    required
                    name="street"
                    label="Endereço da Praça"
                    onChange={handleChange}
                    defaultValue={
                      dadoState?.viewData && responseLocation?.street
                    }
                    disabled={dadoState?.viewData && true}
                  />
                  <Select
                    name="ld_impacto_uuid"
                    label="Você classifica sua filmagem como sendo:"
                    placeholder="Selecione"
                    required
                    questionTooltip="Clique aqui para saber mais"
                    questionOnClick={() => setOpenModalPorteFilmagem(true)}
                    options={impactoSelectList}
                    style={selectCustomStyles}
                    onChange={value => {
                      handleSelectChange('ld_impacto_uuid', value);
                      setShowDescrAltoImpactoLocalField(
                        value.label === 'alto impacto no local',
                      );
                    }}
                    isDisabled={dadoState?.viewData && true}
                  />
                </Wrap>
                <ConditionalContainer show={showDescrAltoImpactoLocalField}>
                  <Wrap>
                    <Textarea
                      type="text"
                      name="descr_alto_impacto_local"
                      label="Comente qual o desafio da sua produção para auxiliarmos em sua viabilização"
                      onChange={handleChange}
                      required
                      rows="3"
                      defaultValue={
                        dadoState?.viewData &&
                        responseLocation?.locacao_default
                          ?.descr_alto_impacto_local
                      }
                      disabled={dadoState?.viewData && true}
                    />
                  </Wrap>
                </ConditionalContainer>

                <Wrap>
                  <DateFormMultiInput
                    label="Data da Filmagem"
                    dates={datasFilmagemInputs}
                    setDates={setDatasFilmagemInputs}
                    setIsLoading={setLoading}
                    isViewMode={dadoState?.viewData}
                    dateKeyName="data_filmagem"
                    isAdminRequest={isAdminRequest}
                    isRequired
                  />

                  <HourFormMultiInput
                    label="Hora da Filmagem (Início - Fim)"
                    hours={horasFilmagemInputs}
                    setHours={setHorasFilmagemInputs}
                    setIsLoading={setLoading}
                    isViewMode={dadoState?.viewData}
                    hourBeginKeyName="inicio"
                    hourEndKeyName="fim"
                    tooltip="Incluir horário de montagem/desmontagem"
                    isAdminRequest={isAdminRequest}
                    isRequired
                  />
                </Wrap>
                <Wrap>
                  <Input
                    type="number"
                    name="tamanho_equipe_tecnica"
                    label="Tamanho da Equipe Técnica"
                    onChange={handleChange}
                    required
                    defaultValue={
                      dadoState.viewData &&
                      responseLocation?.locacao_default?.tamanho_equipe_tecnica
                    }
                    disabled={dadoState.viewData && true}
                  />
                  <Input
                    type="number"
                    name="tamanho_do_elenco"
                    label="Tamanho do elenco"
                    onChange={handleChange}
                    required
                    defaultValue={
                      dadoState.viewData &&
                      responseLocation?.locacao_default?.tamanho_do_elenco
                    }
                    disabled={dadoState.viewData && true}
                  />
                </Wrap>
                <Wrap>
                  <Textarea
                    type="text"
                    name="descricao_cena"
                    label="Descrição da Cena"
                    onChange={handleChange}
                    rows="3"
                    required
                    defaultValue={
                      dadoState?.viewData &&
                      responseLocation?.locacao_default?.descricao_cena
                    }
                    disabled={dadoState?.viewData && true}
                  />
                </Wrap>

                <Wrap>
                  <LimiterInputWidth w50>
                    <ChoiceButtonLocacao
                      label="Já possui local definido para filmagem?"
                      onClickTrue={handleLocalFilmagemTrue}
                      onClickFalse={handleLocalFilmagemFalse}
                      selected={localFilmagem}
                      required
                      isDisabled={dadoState?.viewData && true}
                      error={errorsForm.localFilmagem === true && 'Obrigatório'}
                    />
                  </LimiterInputWidth>
                </Wrap>

                <ConditionalContainer show={localFilmagem}>
                  <Wrap>
                    <LimiterInputWidth w50>
                      <ChoiceButtonLocacao
                        label="Selecione uma opção"
                        onClickTrue={handlePontoFixoTrajetoTrue}
                        onClickFalse={handlePontoFixoTrajetoFalse}
                        selected={pontoFixoTrajeto}
                        required
                        isDisabled={dadoState?.viewData && true}
                        error={
                          errorsForm.pontoFixoTrajeto === true && 'Obrigatório'
                        }
                        yesLabelValue="Ponto(s) Fixo(s)"
                        noLabelValue="Trajeto"
                      />
                    </LimiterInputWidth>
                  </Wrap>
                  <ConditionalContainer
                    show={pontoFixoTrajeto === true}
                    mgTop={15}
                  >
                    <Wrap>
                      <Select
                        name="ld_instalacoes"
                        label="Instalações"
                        placeholder="Selecione"
                        options={instalacoesList}
                        style={selectCustomStyles}
                        onChange={handleMultiSelectInstalacao}
                        isMulti
                        required
                        isDisabled={dadoState?.viewData && true}
                      />
                      <ConditionalContainer show={showOutraInstalacaoField}>
                        <LimiterInputWidth w75>
                          <Input
                            type="text"
                            name="outra_instalacao"
                            label="Outro Instalação"
                            required
                            onChange={handleChange}
                            defaultValue={responseLocation?.outra_instalacao}
                            disabled={dadoState?.viewData && true}
                          />
                        </LimiterInputWidth>
                      </ConditionalContainer>
                      <Select
                        name="ld_area_pavimentada"
                        label="Área Pavimentada"
                        placeholder="Selecione"
                        options={pavimentadaList}
                        style={selectCustomStyles}
                        onChange={handleMultiSelectAreaPavimentada}
                        isMulti
                        required
                        isDisabled={dadoState?.viewData && true}
                      />
                    </Wrap>
                  </ConditionalContainer>

                  <ConditionalContainer
                    show={pontoFixoTrajeto === false}
                    mgTop={15}
                  >
                    <Wrap>
                      <Input
                        type="text"
                        name="trajeto"
                        label="Trajeto"
                        required
                        onChange={handleChange}
                        defaultValue={
                          dadoState?.viewData &&
                          responseLocation?.locacao_default.trajeto
                        }
                        disabled={dadoState?.viewData && true}
                      />
                    </Wrap>
                    <Wrap>
                      <File
                        label="Croqui demarcando área de ocupação:"
                        attach={dataCroquiFile}
                        textFile="Nenhum arquivo selecionado"
                        name="croqui_file"
                        required
                        inputRef={croquiFileRef}
                        onChange={handleFileChange}
                        onClick={handleCroquiFile}
                        error={errorsForm.croquiFile === true && 'Obrigatório'}
                        link={fileCroqui?.length > 0 && fileCroqui[0].url}
                        isDisabled={dadoState?.viewData && true}
                      />
                    </Wrap>

                    <Wrap>
                      <LimiterInputWidth w50>
                        <ChoiceButtonLocacao
                          label="Você precisa isolar alguma área e/ou interferir no fluxo dos frequentadores?"
                          onClickTrue={handleIsolarLocalTrue}
                          onClickFalse={handleIsolarLocalFalse}
                          selected={isolarLocal}
                          required
                          isDisabled={dadoState?.viewData && true}
                          error={
                            errorsForm.isolarLocal === true && 'Obrigatório'
                          }
                        />
                      </LimiterInputWidth>
                    </Wrap>

                    <ConditionalContainer show={isolarLocal}>
                      <Wrap>
                        <Textarea
                          type="text"
                          name="fluxo_area"
                          label="Descrição do Local"
                          onChange={handleChange}
                          rows="2"
                          required
                          defaultValue={
                            dadoState?.viewData &&
                            responseLocation?.locacao_default.fluxo_area
                          }
                          disabled={dadoState?.viewData && true}
                        />
                      </Wrap>
                    </ConditionalContainer>
                  </ConditionalContainer>
                </ConditionalContainer>

                <Wrap>
                  <LimiterInputWidth w50>
                    <ChoiceButtonLocacao
                      label="Haverá alguma intervenção de arte no local?"
                      onClickTrue={handleIntervencaoArteTrue}
                      onClickFalse={handleIntervencaoArteFalse}
                      selected={intervencaoArte}
                      required
                      isDisabled={dadoState?.viewData && true}
                      error={
                        errorsForm.intervencaoArte === true && 'Obrigatório'
                      }
                    />
                  </LimiterInputWidth>
                </Wrap>
                <ConditionalContainer show={intervencaoArte}>
                  <Wrap>
                    <File
                      label="Relatório de Arte:"
                      attach={dataRelatorioArteFile}
                      textFile="Nenhum arquivo selecionado"
                      name="relatorio_arte_file"
                      inputRef={relatorioArteRef}
                      onChange={handleFileChange}
                      onClick={handleRelatorioArteFile}
                      required
                      error={
                        errorsForm.relatorioArteFile === true && 'Obrigatório'
                      }
                      link={fileArte?.length > 0 && fileArte[0].url}
                      isDisabled={dadoState?.viewData && true}
                    />
                  </Wrap>
                  <Wrap>
                    <Textarea
                      type="text"
                      name="desc_intervencao_arte"
                      label="Descreva a(s) intervenção(ões)"
                      onChange={handleChange}
                      rows="2"
                      required
                      defaultValue={
                        dadoState?.viewData &&
                        responseLocation?.locacao_default.desc_intervencao_arte
                      }
                      disabled={dadoState?.viewData && true}
                    />
                  </Wrap>
                </ConditionalContainer>
                <Wrap>
                  <LimiterInputWidth w50>
                    <Select
                      name="ld_equipamento_filmagem"
                      label="Qual a sua estrutura e equipamentos de filmagem:"
                      placeholder="Selecione"
                      options={equipamentosSelectList}
                      style={selectCustomStyles}
                      onChange={handleMultiSelectEquipamentos}
                      isMulti
                      required
                      isDisabled={dadoState?.viewData && true}
                    />
                  </LimiterInputWidth>
                  <ConditionalContainer show={showOutroEquipamentoField}>
                    <LimiterInputWidth w50>
                      <Input
                        type="text"
                        name="outro_equipamento"
                        label="Outro Equipamento"
                        required
                        onChange={handleChange}
                        defaultValue={
                          responseLocation?.locacao_default?.outro_equipamento
                        }
                        disabled={dadoState?.viewData && true}
                      />
                    </LimiterInputWidth>
                  </ConditionalContainer>
                </Wrap>
                <ConditionalContainer show={showDescrEquipamentoFilmagemField}>
                  <Wrap>
                    <Textarea
                      label="Descreva a(s) extensão(ões)"
                      required
                      name="descricoes_equipamento_filmagem"
                      onChange={handleChange}
                      rows="3"
                      defaultValue={
                        dadoState?.viewData &&
                        responseLocation?.locacao_default
                          ?.descricoes_equipamento_filmagem
                      }
                      disabled={dadoState?.viewData && true}
                    />
                  </Wrap>
                </ConditionalContainer>
                <Wrap style={{ alignItems: 'flex-end' }}>
                  <LimiterInputWidth w25>
                    <ChoiceButtonLocacao
                      label="Haverá gerador?"
                      onClickTrue={handleGeradorTrue}
                      onClickFalse={handleGeradorFalse}
                      selected={gerador}
                      required
                      isDisabled={dadoState?.viewData && true}
                      error={errorsForm.gerador === true && 'Obrigatório'}
                    />
                  </LimiterInputWidth>
                </Wrap>
                <ConditionalContainer show={gerador}>
                  <Wrap style={{ alignItems: 'flex-end' }}>
                    <LimiterInputWidth w25>
                      <ChoiceButtonLocacao
                        label="Blimpado/Silencioso ou Não-Blimpado?"
                        onClickTrue={handleBlimpadorTrue}
                        onClickFalse={handleBlimpadorFalse}
                        selected={blimpado}
                        required
                        isDisabled={dadoState?.viewData && true}
                        error={errorsForm.blimpado === true && 'Obrigatório'}
                        yesLabelValue="Blimpado"
                        noLabelValue="Não-Blimpado"
                      />
                    </LimiterInputWidth>

                    <LimiterInputWidth w25>
                      <ChoiceButtonLocacao
                        label="Gerador portátil ou ficará sobre um veículo?"
                        onClickTrue={handleGeradorPortatilTrue}
                        onClickFalse={handleGeradorPortatilFalse}
                        selected={geradorPortatil}
                        required
                        isDisabled={dadoState?.viewData && true}
                        error={
                          errorsForm.geradorPortatil === true && 'Obrigatório'
                        }
                        yesLabelValue="Gerador portátil"
                        noLabelValue="Sobre um veículo"
                      />
                    </LimiterInputWidth>

                    <ConditionalContainer show={geradorPortatil === false}>
                      <LimiterInputWidth w50>
                        <Input
                          type="text"
                          name="veiculo_gerador"
                          label="Placa do Veículo"
                          onChange={handleChange}
                          required
                          defaultValue={
                            dadoState?.viewData &&
                            responseLocation?.locacao_default?.veiculo_gerador
                          }
                          disabled={dadoState?.viewData && true}
                        />
                      </LimiterInputWidth>
                    </ConditionalContainer>
                  </Wrap>
                  <Wrap>
                    <LimiterInputWidth w50>
                      <Input
                        type="text"
                        name="local_gerador"
                        label="Local do Gerador"
                        onChange={handleChange}
                        required
                        disabled={dadoState?.viewData && true}
                        defaultValue={
                          dadoState?.viewData && responseLocation?.local_gerador
                        }
                      />
                    </LimiterInputWidth>
                  </Wrap>
                </ConditionalContainer>

                <Wrap>
                  <LimiterInputWidth w50>
                    <ChoiceButtonLocacao
                      label="Precisará montar Base de Apoio no local?"
                      onClickTrue={handleBaseLocalTrue}
                      onClickFalse={handleBaseLocalFalse}
                      selected={baseLocal}
                      required
                      isDisabled={dadoState?.viewData && true}
                      error={errorsForm.baseLocal === true && 'Obrigatório'}
                    />
                  </LimiterInputWidth>
                </Wrap>

                <ConditionalContainer show={baseLocal}>
                  <Wrap style={{ marginBottom: 0 }}>
                    <LimiterInputWidth w50>
                      <Select
                        name="ld_finalidade_base_apoio"
                        label="Selecione as Finalidades"
                        placeholder="Selecione"
                        options={finalidadeSelectList}
                        style={selectCustomStyles}
                        required
                        onChange={handleMultiSelectFinalidades}
                        isMulti
                        isDisabled={dadoState?.viewData && true}
                      />
                    </LimiterInputWidth>
                    <ConditionalContainer show={showOutroFinalidadeField}>
                      <Input
                        type="text"
                        name="outro_finalidade"
                        label="Outra Finalidade"
                        onChange={handleChange}
                        required
                        defaultValue={
                          dadoState?.viewData &&
                          responseLocation?.locacao_default.outro_finalidade
                        }
                        disabled={dadoState?.viewData && true}
                      />
                    </ConditionalContainer>
                  </Wrap>

                  <Wrap style={{ alignItems: 'flex-end' }}>
                    <LimiterInputWidth w50>
                      <Input
                        type="text"
                        name="local_base_apoio"
                        label="Descreva local da base de apoio"
                        onChange={handleChange}
                        required
                        defaultValue={
                          dadoState?.viewData &&
                          responseLocation?.locacao_default.local_base_apoio
                        }
                        disabled={dadoState?.viewData && true}
                      />
                    </LimiterInputWidth>

                    <LimiterInputWidth w25 style={{ marginRight: 0 }}>
                      <Input
                        type="number"
                        step="0.01"
                        name="dimensao_base_apoio"
                        label="Descreva a dimensão estimada da área"
                        onChange={handleChange}
                        defaultValue={
                          dadoState?.viewData &&
                          responseLocation?.locacao_default.dimensao_base_apoio
                        }
                        disabled={dadoState?.viewData && true}
                      />
                    </LimiterInputWidth>

                    <BoxHeader style={{ justifyContent: 'center', width: 50 }}>
                      <span className="boxText" style={{ color: '#828282' }}>
                        ou
                      </span>
                    </BoxHeader>

                    <LimiterInputWidth w25>
                      <Input
                        type="number"
                        name="quantidade_barracas"
                        label="Descreva a quantidade de barracas a serem montadas"
                        onChange={handleChange}
                        defaultValue={
                          dadoState?.viewData &&
                          responseLocation?.locacao_default.quantidade_barracas
                        }
                        disabled={dadoState?.viewData && true}
                      />
                    </LimiterInputWidth>
                  </Wrap>
                </ConditionalContainer>

                <Wrap>
                  <LimiterInputWidth w25>
                    <ChoiceButtonLocacao
                      label="Captação de som direto?"
                      onClickTrue={handleCaptacaoSomDiretoTrue}
                      onClickFalse={handleCaptacaoSomDiretoFalse}
                      selected={captacaoSomDireto}
                      required
                      isDisabled={dadoState?.viewData && true}
                      error={
                        errorsForm.captacaoSomDireto === true && 'Obrigatório'
                      }
                    />
                  </LimiterInputWidth>
                </Wrap>

                <Wrap>
                  <LimiterInputWidth w50>
                    <ChoiceButtonLocacao
                      label="Haverá som na filmagem?"
                      onClickTrue={handleSomFilmagemTrue}
                      onClickFalse={handleSomFilmagemFalse}
                      selected={somFilmagem}
                      required
                      error={errorsForm?.somFilmagem === true && 'Obrigatório'}
                      isDisabled={dadoState?.viewData && true}
                    />
                  </LimiterInputWidth>
                </Wrap>

                <ConditionalContainer show={somFilmagem}>
                  <Wrap>
                    <LimiterInputWidth w75>
                      <Select
                        name="ld_som_filmagem"
                        label="Sons de Filmagem"
                        placeholder="Selecione"
                        style={selectCustomStyles}
                        required
                        options={somFilmagemSelectList}
                        onChange={handleMultiSelectSomFilmagem}
                        isMulti
                        isDisabled={dadoState?.viewData && true}
                      />
                    </LimiterInputWidth>
                  </Wrap>

                  <ConditionalContainer show={showOutroSomFilmagemField}>
                    <Wrap>
                      <Input
                        type="text"
                        name="outro_som_filmagem"
                        label="Outro Som de Filmagem"
                        onChange={handleChange}
                        defaultValue={
                          dadoState?.viewData &&
                          responseLocation?.locacao_default?.outro_som_filmagem
                        }
                        disabled={dadoState?.viewData && true}
                      />
                    </Wrap>
                  </ConditionalContainer>

                  <ConditionalContainer show={showDescrSomFilmagemField}>
                    <Wrap>
                      <Textarea
                        label="Descreva a(s) característica(s)"
                        required
                        name="descricoes_som_filmagem"
                        onChange={handleChange}
                        rows="3"
                        defaultValue={
                          dadoState?.viewData &&
                          responseLocation?.locacao_default
                            ?.descricoes_som_filmagem
                        }
                        disabled={dadoState?.viewData && true}
                      />
                    </Wrap>
                  </ConditionalContainer>
                </ConditionalContainer>

                <Wrap>
                  <LimiterInputWidth w25>
                    <ChoiceButtonLocacao
                      label="Drone"
                      onClickTrue={handleDroneTue}
                      onClickFalse={handleDroneFalse}
                      selected={drone}
                      required
                      isDisabled={dadoState?.viewData && true}
                      error={errorsForm.drone === true && 'Obrigatório'}
                    />
                  </LimiterInputWidth>
                </Wrap>
                {drone === true && (
                  <Wrap>
                    <Textarea
                      name="autorizacao_drones"
                      onChange={handleChange}
                      rows="4"
                      value="Para filmagens com drones: o Espaço Aéreo não é de administração municipal, mas sim da
                    Federação/União, portanto, não faz parte do campo de atuação da SPFilm. A autorização para o uso
                    de drones deve ser solicitada diretamente à Agência Nacional de Aviação Civil (ANAC), mediante
                    cadastro no Sistema SARPAS, disponibilizado no site do Departamento de Controle do Espaço Aéreo
                    (DECEA)."
                      disabled
                    />
                  </Wrap>
                )}
                <Wrap>
                  <LimiterInputWidth w50>
                    <ChoiceButtonLocacao
                      label="Efeitos Especiais"
                      onClickTrue={handleEfeitosEspeciaisTrue}
                      onClickFalse={handleEfeitosEspeciaisFalse}
                      selected={efeitosEspeciais}
                      required
                      isDisabled={dadoState?.viewData && true}
                      error={
                        errorsForm.efeitosEspeciais === true && 'Obrigatório'
                      }
                    />
                  </LimiterInputWidth>
                  <ConditionalContainer show={efeitosEspeciais}>
                    <Select
                      name="ld_efeitos_especiais_uuid"
                      label="Efeitos Especiais"
                      placeholder="Selecione"
                      style={selectCustomStyles}
                      required
                      options={efeitoEspecialSelectList}
                      onChange={value => {
                        handleSelectChange('ld_efeitos_especiais_uuid', value);
                      }}
                      isDisabled={dadoState?.viewData && true}
                    />
                  </ConditionalContainer>
                </Wrap>
                <Wrap>
                  <LimiterInputWidth w50>
                    <ChoiceButtonLocacao
                      label="Haverá animais de cena?"
                      onClickTrue={handleHaveraAnimaisTrue}
                      onClickFalse={handleHaveraAnimaisFalse}
                      selected={haveraAnimais}
                      required
                      isDisabled={dadoState?.viewData && true}
                      error={errorsForm.haveraAnimais === true && 'Obrigatório'}
                    />
                  </LimiterInputWidth>
                </Wrap>
                <ConditionalContainer show={haveraAnimais}>
                  <Wrap>
                    <Textarea
                      type="text"
                      name="descricao_animais"
                      label="Descreva os animais"
                      onChange={handleChange}
                      rows="2"
                      required
                      defaultValue={
                        dadoState?.viewData &&
                        responseLocation?.locacao_default?.animais_em_cena
                      }
                      disabled={dadoState?.viewData && true}
                    />
                  </Wrap>
                </ConditionalContainer>
                <Wrap>
                  <ChoiceButtonLocacao
                    label="Haverá utilização de algum equipamento esportivo?"
                    onClickTrue={handleEquipamentoEsportivoTrue}
                    onClickFalse={handleEquipamentoEsportivoFalse}
                    selected={equipamentoEsportivo}
                    required
                    error={
                      errorsForm.equipamentoEsportivo === true && 'Obrigatório'
                    }
                    isDisabled={dadoState?.viewData && true}
                  />
                </Wrap>
                <ConditionalContainer show={equipamentoEsportivo}>
                  <Wrap>
                    <LimiterInputWidth w50>
                      <Select
                        name="l_equipamentos_esportivos"
                        label="Equipamentos Esportivos"
                        placeholder="Selecione"
                        options={equipamentoEsportivoSelectList}
                        style={selectCustomStyles}
                        onChange={handleMultiSelectEquipEsportivos}
                        isMulti
                        required
                        isDisabled={dadoState?.viewData && true}
                      />
                    </LimiterInputWidth>
                    <ConditionalContainer show={showOutroEquipEsportivoField}>
                      <LimiterInputWidth w50>
                        <Input
                          type="text"
                          name="outro_equipamento_esportivo"
                          label="Outro Equipamento Esportivo"
                          onChange={handleChange}
                          required
                          defaultValue={
                            dadoState?.viewData &&
                            responseLocation?.outro_equipamento_esportivo
                          }
                          disabled={dadoState?.viewData && true}
                        />
                      </LimiterInputWidth>
                    </ConditionalContainer>
                  </Wrap>
                </ConditionalContainer>
                <Wrap>
                  <ChoiceButtonLocacao
                    label="Haverá alguma intervenção na flora?"
                    onClickTrue={handleIntervencaoFloraTrue}
                    onClickFalse={handleIntervencaoFloraFalse}
                    selected={intervencaoFlora}
                    required
                    isDisabled={dadoState?.viewData && true}
                    error={
                      errorsForm.intervencaoFlora === true && 'Obrigatório'
                    }
                  />
                </Wrap>
                <ConditionalContainer show={intervencaoFlora}>
                  <Wrap>
                    <Textarea
                      type="text"
                      name="intervencao_na_flora"
                      label="Descreva"
                      onChange={handleChange}
                      row="2"
                      required
                      defaultValue={responseLocation?.intervencao_na_flora}
                      disabled={dadoState?.viewData && true}
                    />
                  </Wrap>
                </ConditionalContainer>

                <Wrap>
                  <LimiterInputWidth w50>
                    <ChoiceButtonLocacao
                      label="Haverá projeção visível a partir de logradouro público?"
                      onClickTrue={handleProjecaoTrue}
                      onClickFalse={handleProjecaoFalse}
                      selected={projecao}
                      required
                      isDisabled={dadoState?.viewData && true}
                      error={errorsForm.projecao === true && 'Obrigatório'}
                    />
                  </LimiterInputWidth>
                </Wrap>

                <ConditionalContainer show={projecao}>
                  <Wrap>
                    <File
                      label="Conteúdo da Projeção:"
                      attach={dataConteudoProjecaoFile}
                      textFile="Nenhum arquivo selecionado"
                      name="conteudo_projecao_file"
                      inputRef={conteudoProjecaoRef}
                      onChange={handleFileChange}
                      required
                      onClick={handleConteudoProjecaoFile}
                      error={
                        errorsForm.conteudoProjecaoFile === true &&
                        'Obrigatório'
                      }
                      link={fileProjecao?.length > 0 && fileProjecao[0].url}
                      isDisabled={dadoState?.viewData && true}
                    />
                  </Wrap>
                  <Wrap style={{ alignItems: 'flex-end' }}>
                    <LimiterInputWidth w50>
                      <ChoiceButtonLocacao
                        label="Será projetado em imóvel público ou privado?"
                        onClickTrue={handlePublicoPrivadoTrue}
                        onClickFalse={handlePublicoPrivadoFalse}
                        selected={publicoPrivado}
                        required
                        isDisabled={dadoState?.viewData && true}
                        error={
                          errorsForm.publicoPrivado === true && 'Obrigatório'
                        }
                        yesLabelValue="Público"
                        noLabelValue="Privado"
                      />
                    </LimiterInputWidth>
                  </Wrap>

                  <Wrap>
                    <Textarea
                      type="text"
                      name="estrutura_projecao"
                      label="Descreva a Estrutura para a Projeção"
                      onChange={handleChange}
                      required
                      defaultValue={
                        dadoState?.viewData &&
                        responseLocation?.locacao_default?.estrutura_projecao
                      }
                      disabled={dadoState?.viewData && true}
                    />
                  </Wrap>

                  <Wrap>
                    <Textarea
                      type="text"
                      name="instalacao_estrutura_projecao"
                      label="Descreva local de instalação para estrutura de projeção"
                      onChange={handleChange}
                      required
                      defaultValue={
                        dadoState?.viewData &&
                        responseLocation?.locacao_default
                          ?.instalacao_estrutura_projecao
                      }
                      disabled={dadoState?.viewData && true}
                    />
                  </Wrap>

                  <Wrap>
                    <LimiterInputWidth w50>
                      <ChoiceButtonLocacao
                        label="Haverá exibição de logomarca na projeção? Se sim, qual porcentagem ocupará da área total da projeção e por quanto tempo será projetada?"
                        onClickTrue={handleProjecaoLogoTrue}
                        onClickFalse={handleProjecaoLogoFalse}
                        selected={projecaoLogo}
                        required
                        isDisabled={dadoState?.viewData && true}
                        error={
                          errorsForm.projecaoLogo === true && 'Obrigatório'
                        }
                      />
                    </LimiterInputWidth>
                  </Wrap>

                  <ConditionalContainer show={projecaoLogo}>
                    <Wrap>
                      <Input
                        type="number"
                        step="0.01"
                        name="porcentagem_projecao"
                        label="Porcentagem que a projeção irá ocupar"
                        onChange={handleChange}
                        required
                        defaultValue={
                          dadoState?.viewData &&
                          responseLocation?.locacao_default
                            ?.porcentagem_projecao
                        }
                        disabled={dadoState?.viewData && true}
                      />
                      <Input
                        type="time"
                        name="area_tempo_projeção"
                        label="Tempo de Projeção"
                        required
                        onChange={handleChange}
                        defaultValue={
                          dadoState?.viewData &&
                          responseLocation?.locacao_default?.area_tempo_projeção
                        }
                        disabled={dadoState?.viewData && true}
                      />
                    </Wrap>
                  </ConditionalContainer>
                </ConditionalContainer>

                <Wrap>
                  <LimiterInputWidth w50>
                    <ChoiceButtonLocacao
                      label="Haverá desligamento de iluminação no local?"
                      onClickTrue={handleDesligarLuzTrue}
                      onClickFalse={handleDesligarLuzFalse}
                      selected={desligarLuz}
                      required
                      isDisabled={dadoState?.viewData && true}
                      error={errorsForm.desligarLuz === true && 'Obrigatório'}
                    />
                  </LimiterInputWidth>
                </Wrap>

                <ConditionalContainer show={desligarLuz}>
                  <Wrap>
                    <File
                      label="Arquivo do local:"
                      attach={dataIluminacaoFile}
                      textFile="Nenhum arquivo selecionado"
                      name="iluminacao_file"
                      inputRef={iluminacaoFileRef}
                      required
                      onChange={handleFileChange}
                      onClick={handleIluminacaoFile}
                      error={
                        errorsForm.iluminacaoFile === true && 'Obrigatório'
                      }
                      link={fileLuz?.length > 0 && fileLuz[0].url}
                      isDisabled={dadoState?.viewData && true}
                    />
                  </Wrap>
                </ConditionalContainer>

                <Wrap style={{ flexDirection: 'column' }}>
                  {dadoState?.viewData && intervencoesVia ? (
                    <>
                      <LimiterInputWidth w50>
                        <Select
                          name="utilizacao_associadas"
                          label="Intervenções na via"
                          placeholder="Selecione"
                          options={responseLocation?.utilizacao_associadas?.map(
                            ({ uuid, name_view, protocol, endpoint }) => ({
                              label: `${name_view} - ${protocol}`,
                              value: { uuid, endpoint },
                            }),
                          )}
                          style={selectCustomStyles}
                          onChange={value => {
                            handleSelectChange('utilizacao_associadas', value);
                          }}
                        />
                      </LimiterInputWidth>

                      {Object.values(formData?.utilizacao_associadas || {})
                        .length > 0 && (
                        <Wrap>
                          <FormChoiceButton
                            nomeProjeto={dadoState?.nome_projeto}
                            viewData={{
                              is_admin: isAdminRequest,
                              uuid: formData?.utilizacao_associadas?.uuid,
                              endpoint:
                                formData?.utilizacao_associadas?.endpoint,
                            }}
                          />
                        </Wrap>
                      )}
                    </>
                  ) : (
                    <ChoiceButtonLocacao
                      label="Necessita de intervenções na via?"
                      onClickTrue={handleIntervencoesViaTrue}
                      onClickFalse={handleIntervencoesViaFalse}
                      selected={intervencoesVia}
                      required
                      isDisabled={dadoState?.viewData && true}
                      error={
                        errorsForm.intervencoesVia === true && 'Obrigatório'
                      }
                    />
                  )}
                </Wrap>

                <Wrap>
                  <Input
                    type="text"
                    name="especificidades"
                    label=" Descreva especificidades não contempladas nas perguntas acima"
                    onChange={handleChange}
                    defaultValue={
                      dadoState?.viewData &&
                      responseLocation?.locacao_default?.especificidades
                    }
                    disabled={dadoState?.viewData && true}
                  />
                </Wrap>

                <Wrap style={{ flexDirection: 'column' }}>
                  {dadoState?.viewData && reservasVagas ? (
                    <>
                      <LimiterInputWidth w50>
                        <Select
                          name="reservas_vagas_locacao"
                          label="Reservas de Vagas"
                          placeholder="Selecione"
                          options={responseLocation?.locacao_via_externa?.map(
                            ({
                              uuid,
                              address,
                              number,
                              neighborhood,
                              endpoint,
                            }) => ({
                              label: `${address}, ${number}, ${neighborhood}`,
                              value: { uuid, endpoint },
                            }),
                          )}
                          style={selectCustomStyles}
                          onChange={value => {
                            handleSelectChange('reservas_vagas_locacao', value);
                          }}
                        />
                      </LimiterInputWidth>

                      {formData?.reservas_vagas_locacao && (
                        <Wrap>
                          <FormChoiceButton
                            nomeProjeto={dadoState?.nome_projeto}
                            viewData={{
                              is_admin: isAdminRequest,
                              uuid: formData?.reservas_vagas_locacao?.uuid,
                              endpoint: 'reservas-vagas-vinculado',
                            }}
                          />
                        </Wrap>
                      )}
                    </>
                  ) : (
                    <ChoiceButtonLocacao
                      label="Necessita de reserva de vagas em via próxima?"
                      onClickTrue={handleReservasVagasTrue}
                      onClickFalse={handleReservasVagasFalse}
                      selected={reservasVagas}
                      required
                      isDisabled={dadoState?.viewData && true}
                      error={errorsForm.reservasVagas === true && 'Obrigatório'}
                    />
                  )}
                </Wrap>

                {responseLocation?.documents?.length > 0 && isAdminRequest && (
                  <Wrap>
                    <Documents
                      documents={responseLocation?.documents}
                      uuid={responseLocation.uuid}
                    />
                  </Wrap>
                )}

                {responseLocation?.created_at && isAdminRequest && (
                  <Wrap>
                    <LimiterInputWidth w50>
                      <Input
                        type="text"
                        name="created_at"
                        label="Data de criação"
                        defaultValue={format(
                          new Date(responseLocation?.created_at),
                          'dd/MM/yyyy HH:mm',
                        )}
                        disabled
                      />
                    </LimiterInputWidth>
                  </Wrap>
                )}
              </WhiteBox>

              <Chat
                uuid={responseLocation?.locacao_default?.uuid}
                chatKeyFilter="locacao_default"
                locacaoNameView={responseLocation?.name_view}
              />

              {responseLocation?.valor_locacao && isAdminRequest && (
                <ValorLocacao
                  locacaoEndpoint={dadoState?.viewData?.endpoint}
                  locacaoUuid={responseLocation?.uuid}
                  viewData={responseLocation?.valor_locacao}
                />
              )}

              {responseLocation && isAdminRequest && (
                <ModalidadePagamento
                  locacaoEndpoint={dadoState?.viewData?.endpoint}
                  locacaoUuid={responseLocation?.uuid}
                  viewData={responseLocation?.modalidade_pagamento}
                />
              )}

              {responseLocation && isAdminRequest && (
                <WorkStatusSwitch
                  data={{
                    entity: 'locacao-default',
                    uuid: responseLocation?.locacao_default?.uuid,
                  }}
                />
              )}

              {responseLocation && isAdminRequest && (
                <ObservacoesChat workUuid={responseLocation?.work_uuid} />
              )}

              {dadoState?.uuid && !dadoState.viewData && (
                <Button
                  type="submit"
                  btType="#26A2B1"
                  label="Enviar"
                  full
                  width="140px"
                  loading={loading}
                  style={{ position: 'relative', bottom: '35px' }}
                />
              )}

              {Object.keys(responseLocation || {}).length > 0 && (
                <Link
                  to={{
                    pathname: 'redireciona-endpoint',
                    search: `query=${encodeURIComponent(
                      CryptoJS.AES.encrypt(
                        JSON.stringify({
                          is_admin: isAdminRequest,
                          uuid: responseLocation?.uuid,
                          endpoint: responseLocation?.endpoint,
                          mode: 'edit',
                          nome_projeto: responseLocation?.titulo_obra,
                        }),
                        tenancy_env('REACT_APP_API_BASE_URL'),
                      ).toString(),
                    )}`,
                  }}
                  target="_blank"
                  style={{
                    textDecoration: 'none',
                    width: '100%',
                    maxWidth: '140px',
                    position: 'relative',
                    bottom: '35px',
                  }}
                >
                  <ActionButton
                    style={{
                      backgroundColor: '#828282',
                    }}
                  >
                    Editar
                  </ActionButton>
                </Link>
              )}
            </Form>
          </PageContent>
        </PageContainer>
      </>
    );
  }

  return (
    <>
      <Header>
        <LogoIcon />
        {!isAdminRequest && <NavBarHeader />}
      </Header>

      <BannerHeader>
        <BannerContent>
          <TextBanner>
            <h1>Filmagens em Praças</h1>
            {!isAdminRequest && (
              <span>
                Home | Obras | {dadoState?.nome_projeto} | Locações | Praças
              </span>
            )}
          </TextBanner>
        </BannerContent>
      </BannerHeader>

      {renderLocacao()}

      <PageFooter>
       <img
          src={clientResources.images.system.spcineLogo}
          alt={clientResources.images.system.altLogo}
        />
        <img
          src={clientResources.images.system.culturaSpLogo}
          alt={clientResources.images.system.altCultura}
        />
      </PageFooter>

      <ModalPorteFilmagem
        openModal={openModalPorteFilmagem}
        closeModal={() => setOpenModalPorteFilmagem(false)}
      />
    </>
  );
};

export default Praca;
